import { Button, Container, Grid, Stack, Typography, Box } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import BrudCrumbs from '../../components/BreadCrumbs';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import {
  getLoanTypeData,
  getBankDropdownData,
  getBankBranchData,
  saveApiData
} from '../../store/Slice/Global/GlobalSlice';
import { getReportingManagerList } from '../../store/Slice/Onboarding/OnboardingSlice';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import { BankOpsApi } from '../../utils/Apis';
import useCallCenterSelector from '../../store/Slice/CallCenterList/CallCenterListSelector';
import {
  getEmployementTypeList,
  getSubEmployementTypeList
} from '../../store/Slice/CallCenterList/CallCenterListSlice';

export default function AddLoginFile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { LoginData } = useLoginSelector();
  const { LoanTypeDrop, BankDrop, BankBranchDrop, CityDrop } = useGlobalSelector();
  const { EmployementTypeData, SubEmployementTypeData } = useCallCenterSelector();

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      customerName: '',
      companyName: '',
      loanType: '',
      amount: '',
      location: '',
      bankId: '',
      branchId: '',
      relationshipManager: '',
      lanId: '',
      dsaName: '',
      source: ''
    }
  });

  const employementType = watch('employementType');
  const subEmployementType = watch('subEmployementType');

  console.log('EmployementTypeData222', EmployementTypeData);

  const options = useMemo(
    () => ({
      employment: Array.isArray(EmployementTypeData)
        ? EmployementTypeData.map((b) => ({
            label: b.employmentCategoryName,
            value: b.employmentCategoryId
          }))
        : [],
      subEmployment: Array.isArray(SubEmployementTypeData)
        ? SubEmployementTypeData.map((b) => ({
            label: b.employmentSubcategoryName,
            value: b.employmentSubcategoryId
          }))
        : [],
      loanType: (LoanTypeDrop || []).map((l) => ({ label: l.label, value: l.value })),
      bank: (BankDrop || []).map((b) => ({ label: b.label, value: b.value })),
      branch: (BankBranchDrop || []).map((b) => ({ label: b.label, value: b.value }))
    }),
    [EmployementTypeData, SubEmployementTypeData, LoanTypeDrop, BankDrop, BankBranchDrop]
  );

  useEffect(() => {
    console.log('LoginData222', LoginData);
    if (!LoginData) return;
    const common = { companyId: LoginData.companyId, userId: LoginData.userId };
    dispatch(getLoanTypeData(common));
    dispatch(getBankDropdownData(common));
    dispatch(getEmployementTypeList({ companyId: LoginData.companyId }));
  }, [LoginData, dispatch]);

  useEffect(() => {
    if (employementType) {
      dispatch(
        getSubEmployementTypeList({
          companyId: LoginData?.companyId,
          returnConfiguredTypesOnly: true,
          employmentCategoryId: employementType
        })
      );
    }
  }, [employementType, LoginData, dispatch]);

  const handleBankChange = useCallback(
    (_, bankId) => {
      if (bankId) {
        dispatch(getBankBranchData(bankId));
        setValue('branchId', '');
      }
    },
    [dispatch, setValue]
  );

  const handleBranchChange = useCallback(
    (_, __, option) => {
      if (option?.cityId) {
        dispatch(getReportingManagerList({ cityId: option.cityId }));
      }
    },
    [dispatch]
  );

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      companyId: LoginData.companyId,
      userId: LoginData.userId,
      amount: Number(data.amount),
      applicantEmploymentType: subEmployementType || ''
    };

    const res = await dispatch(saveApiData(BankOpsApi.addLoginFile, payload));
    if (res?.status === 'success') navigate('/bankops');
  };

  return (
    <Page title="Revenue | Add Login File">
      <Container maxWidth="xl">
        <Box pt={3} pb={3}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="List of Application" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Typography variant="body1" className="headingLineUp headingLineUpOut">
            File Details
          </Typography>
          <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <CustomInput
                    name="customerName"
                    label="Customer Name"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="companyName"
                    label="Company Name"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    type="number"
                    name="contactNumber"
                    label="Contact Number"
                    control={control}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    name="loanType"
                    label="Loan Type"
                    control={control}
                    errors={errors}
                    options={options.loanType}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="amount"
                    label="Amount"
                    control={control}
                    errors={errors}
                    isRequired
                    fieldType="AMOUNT_FIELD"
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="location"
                    label="Location"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    name="cityId"
                    label="City"
                    control={control}
                    errors={errors}
                    options={CityDrop}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    name="bankId"
                    label="Bank Name"
                    control={control}
                    errors={errors}
                    options={options.bank}
                    isRequired
                    onChange={handleBankChange}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    name="branchId"
                    label="Branch Name"
                    control={control}
                    errors={errors}
                    options={options.branch}
                    isRequired
                    onChange={handleBranchChange}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="relationshipManager"
                    label="Relationship Manager"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="rmContactNumber"
                    label="RM Contact Number"
                    type="number"
                    control={control}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="lanId"
                    label="File Number"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomInput
                    name="dsaName"
                    label="DSA Name"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelect
                    name="source"
                    label="Source"
                    control={control}
                    errors={errors}
                    isRequired
                    options={[
                      { label: 'Self', value: 'SELF' },
                      { label: 'Broker', value: 'COMPANY' },
                      { label: 'Channel', value: 'Channel' }
                    ]}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomSelect
                    name="employementType"
                    label="Employement Type"
                    control={control}
                    errors={errors}
                    options={options.employment}
                    isRequired
                  />
                </Grid>
                {options.subEmployment.length > 0 && employementType && (
                  <Grid item xs={12} sm={6} md={4}>
                    <CustomSelect
                      name="subEmployementType"
                      label="Sub Employement Type"
                      control={control}
                      errors={errors}
                      options={options.subEmployment}
                      isRequired
                    />
                  </Grid>
                )}
              </Grid>
              <Box textAlign="right" mt={3}>
                <Button type="submit" variant="contained" className="mainBtn">
                  Submit
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Container>
    </Page>
  );
}
